import { all, fork, takeEvery } from "redux-saga/effects";
import { SET_BRANCH_SELECT, SET_CLIENT_SELECT, SET_COMPANY_SELECT, SET_USER_DATA, SET_USER_TYPE, SET_USER_ROLE } from "./actionType";

function* setClientSelect(action) {
  yield localStorage.setItem("clientSelected", JSON.stringify(action.payload));
}

function* setCompanySelect(action) {
  yield localStorage.setItem("companySelected", JSON.stringify(action.payload));
}

function* setBranchSelect(action) {
  yield localStorage.setItem("branchSelected", JSON.stringify(action.payload));
}

export function* watchSetClientSelect() {
  yield takeEvery(SET_CLIENT_SELECT, setClientSelect);
}

export function* watchSSetCompanySelect() {
  yield takeEvery(SET_COMPANY_SELECT, setCompanySelect);
}

export function* watchSetBranchSelect() {
  yield takeEvery(SET_BRANCH_SELECT, setBranchSelect);
}

function* appSaga() {
  yield all([fork(watchSetClientSelect), fork(watchSSetCompanySelect), fork(watchSetBranchSelect)]);
}

export default appSaga;
